import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { Column, Container, Heading, HeadingPriority, HeadingType, useIsMounted } from '@as/cotopaxi';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../constants/i18nConstants';
import { AccountPaybackEnrichmentForm } from '../../components/account/account-payback-enrichment/AccountPaybackEnrichmentForm';
import { useDispatch, useSelector } from 'react-redux';
import { makeGetCustomerProfile } from '../../redux/customer/selectors/CustomerSelector';
import customerActions from '../../redux/customer/actions/CustomerActions.creators';
import { makeGetSessionState } from '../../redux/session/selectors/SessionSelector';
import { isEmptyObject } from '@as-react/common-utils';
import { Box } from '@yonderland/andes-react';
const AccountPaybackEnrichmentContainer = ({ confirmationUrl, image, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.account);
    const dispatch = useDispatch();
    const profile = useSelector(makeGetCustomerProfile());
    const sessionState = useSelector(makeGetSessionState());
    const isMounted = useIsMounted();
    const handleFinish = () => {
        let redirect = confirmationUrl;
        if (window.location.search) {
            redirect += window.location.search;
        }
        if (window.location.hash) {
            redirect += window.location.hash;
        }
        window.location.href = redirect;
    };
    useEffect(() => {
        dispatch(customerActions.getProfile());
    }, [isMounted]);
    useEffect(() => {
        if (sessionState.uuid && !sessionState.isLoggedIn) {
            handleFinish();
        }
    }, [sessionState]);
    const backgroundStyle = image
        ? {
            backgroundImage: `url(${image.imagePath})`,
            backgroundPosition: 'bottom',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
        }
        : {};
    return (_jsx(Box, { marginInlineEnd: "-2", children: sessionState.isLoggedIn && profile && !isEmptyObject(profile) && (_jsx("div", { style: backgroundStyle, children: _jsx(Container, { children: _jsx(Column, { mobile: 12, tablet: { span: 8, push: 2 }, desktop: { span: 6, push: 3 }, children: _jsxs(Box, { padding: "4", marginInline: "-2", children: [_jsx(Box, { paddingBlockEnd: "6", children: _jsx(Heading, { priority: HeadingPriority.H1, type: HeadingType.EXTRA_TITLE, children: t('account.payback.enrichment.title') }) }), _jsx(Box, { paddingBlockEnd: "6", children: _jsx(Heading, { priority: HeadingPriority.H2, type: HeadingType.SUBTITLE, children: t('account.payback.enrichment.subtitle') }) }), _jsx(AccountPaybackEnrichmentForm, { onFinish: handleFinish, profile: profile })] }) }) }) })) }));
};
export default AccountPaybackEnrichmentContainer;
